import getApi from '../../api/apisauceConfig'
import { WeberTest, WeberTestContent } from '../../model/Audiometry'

export const updateWeberTest = (id: number, payload: Partial<WeberTestContent>) =>
  getApi().put<WeberTest>(`/audiometry/weber_tests/${id}`, payload)
